import { useState } from "react";
import FormComp from "../../../Componentes/FormComp";
import Overlay from "../../../Componentes/Overlay"
import Formulario from "../../../Componentes/Utils/Formulario";
import Modal from "../../../Componentes/Utils/Modal"
import { useModal } from "../../../contexts/ModalContext"
import useApi from "../../../hooks/useApi";
const ModalNovoTipo = ({ categoria, updateTipos, updateCategorias }) => {
    const api = useApi();


    const { closeModal } = useModal();

    const [formValues, setFormValues] = useState({
        tipoRisco: "",
        classificacao: ""
    })

    const handleSubmit = async (e) => {
        e.preventDefault();

        try{

            const formData = new FormData();
            formData.append("tipoRisco", formValues.tipoRisco);
            formData.append("classificacao", formValues.classificacao);
            formData.append("categoria", categoria.uuid);

            await api.post("/Painel/API/Desvios/SaveNewTipoRisco/", formData);

            await updateTipos();
            await updateCategorias();
            closeModal();

        }catch( error ){
            console.log( error );
        }

    }

    return (
        <>
            <Overlay state={true} >
                <Modal header close={closeModal} >
                    <Formulario onSubmit={ handleSubmit } >
                        <FormComp
                            title="TIPO DE RISCO"
                            type="text"
                            placeholder="DIGITE..."
                            name="tipoRisco"
                            changeFunc={(e) => setFormValues(prev => ({ ...prev, tipoRisco: e.target.value.toUpperCase() }))}
                            valor={formValues.tipoRisco}
                            required
                        />
                        <FormComp
                            title="CLASSIFICAÇÃO"
                            type="select"
                            options={[
                                { value: 1, label: "MODERADO" },
                                { value: 2, label: "ALTO" },
                            ]}
                            obj
                            name="classificacao"
                            changeFunc={(e) => setFormValues(prev => ({ ...prev, classificacao: e.target.value }))}
                            valor={formValues.classificacao}
                            required
                        />
                        <FormComp
                            valor="SALVAR"
                            type="submit"
                        />
                    </Formulario>
                </Modal>
            </Overlay>
        </>
    )
}

export default ModalNovoTipo;